import { jsx as _jsx } from "react/jsx-runtime";
import { InnerContainer } from './TabPanel.styled';
export const TabPanel = (props) => {
    const { children, value, index, keepMounted, ...rest } = props;
    const isSelected = value === index;
    return (_jsx(InnerContainer, { role: "tabpanel", id: `tabpanel-${index}`, "aria-labelledby": `tab-${index}`, hidden: !isSelected, ...rest, children: (isSelected || keepMounted) && children }));
};
